<template>
    <div class="login-panel">
        <div class="card card-auth with-shadow">
            <h2 class="auth-heading">
                Login to your account
                <span> Please enter your account credentials. </span>
            </h2>

            <div class="auth-body">
                <b-form @submit.stop.prevent="onSubmit">
                    <b-form-group
                        id="login_username"
                        label="Username"
                        label-for="login-username-input"
                    >
                        <b-form-input
                            id="login_username"
                            v-model="formData.username"
                            v-validate="{ required: true, max: 20, min: 6 }"
                            placeholder="Enter your account username"
                            autocomplete="off"
                            data-vv-name="username"
                            :class="{
                                'is-invalid': errors.has('username'),
                            }"
                        ></b-form-input>
                    </b-form-group>
                    <b-form-group
                        id="login_password"
                        label="Password"
                        type="password"
                        label-for="login-password-input"
                    >
                        <b-form-input
                            id="login-password-input"
                            v-model="formData.password"
                            v-validate="{ required: true, max: 20, min: 6 }"
                            placeholder="Enter your account password"
                            autocomplete="off"
                            type="password"
                            data-vv-name="password"
                            :class="{
                                'is-invalid': errors.has('password'),
                            }"
                        ></b-form-input>
                    </b-form-group>
                    <base-button
                        btn-label="Sign In"
                        btn-type="submit"
                        btn-variant="primary"
                        :disabled="loading"
                        :class="loading ? 'disabled' : ''"
                    ></base-button>
                    <router-link
                        to="auth/forgot-password"
                        class="btn forgot-link btn-link float-right"
                        >Forgot your password?</router-link
                    >
                    <!-- <base-toast></base-toast> -->
                </b-form>
            </div>
        </div>
        <b-modal
            ref="otpmodal"
            size="sm"
            title=""
            hide-footer
            :click-to-close="false"
            :no-close-on-backdrop="true"
            :no-close-on-esc="true"
            @close="onCloseOTPModal"
        >
            <otp-verification-modal
                :hide-mobile="true"
                :is-login-modal="true"
                :data="otpData"
                @verificationStatus="otpResponse"
                @reSendOTP="reSendOTP"
            ></otp-verification-modal>
        </b-modal>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import resource from '@/api/resource'
import OtpVerificationModal from '../../components/registration/OtpVerificationModal'
import axios from 'axios'
const viewBrandingApi = new resource('configurations/branding')

export default {
    /*
    |--------------------------------------------------------------------------
    | Component > components
    |--------------------------------------------------------------------------
    */
    components: {
        OtpVerificationModal,
    },
    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {}, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            formData: this.initializeFormData(),
            otpData: null,
            is_data_fetched: false,
            tempData: null,
            customMessage: '',
            showPassword: false,
        }
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters(['loading', 'user', 'success', 'redirectUrl', 'hasOTP']),
    }, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */

    watch: {
        /**
         * Handle when the user has been updated
         *
         * @return {void}
         */
        user(value) {
            // check if the value is not empty
            // and redirect to inner page
            if (value !== null && value !== undefined) {
                if (this.redirectUrl) {
                    this.$router.push({ path: this.redirectUrl })
                    this.$store.commit('setRedirectUrl', null)
                } else {
                    this.$router.push({ name: 'view-alerts' })
                }
            }
        }, // End of user()
    }, // End of Component > methods

    /*
        |--------------------------------------------------------------------------
        | Component > mounted
        |--------------------------------------------------------------------------
        */
    async created() {
        // Change theme color
        await this.getBrandingData()
        // console.log("Date: "+Date.now())
    }, // End of Component > watch

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        initializeFormData() {
            return {
                username: '',
                password: '',
                loginAt: '',
            }
        }, // End of initializeFormData() methods

        async onSubmit() {
            const result = await this.$validator.validateAll()
            console.log('asdasdsd')

            if (result) {
                try {
                    let encryptedForm = this.$encrypt({
                        ...this.formData,
                        cToken: this.recaptchaResponse,
                    })
                    this.$store.commit('setLoading', true)
                    let resp = await axios
                        .post(`${process.env.VUE_APP_API_URL}auth/login`, {
                            data: encryptedForm,
                        })
                        .then(function (response) {
                            return response
                        })
                        .catch(function (error) {
                            console.log('error', error)
                            if (error.response) {
                                return { error: error.response.data.message }
                            } else if (error.request) {
                                return {
                                    error: 'Server error, please try again later',
                                }
                                // return {error :'Your IP has been blocked, please contact Admin'}
                            } else {
                                // Something happened in setting up the request that triggered an Error
                                return { error: error.message }
                            }
                        })
                    this.forceRerenderRecaptcha = Math.random() * 100

                    console.log('response0------', resp)

                    // authLogin action in auth store
                    if (resp && resp.error) {
                        this.$store.commit('setLoading', false)
                        this.$store.commit('setError', resp.error)
                        return
                    }
                    if (typeof resp.data.data == 'string') {
                        this.tempData = resp
                        this.tempData.data.data = this.$decrypt(
                            this.tempData.data.data
                        )
                    }

                    if (this.tempData) {
                        if (this.tempData.data.data.twoFA) {
                            await this.sendOPT(this.tempData.data.data)
                        } else {
                            await this.loginUser(this.tempData.data.data)
                        }
                    } else {
                        this.$store.commit('setError', 'Could not load data')
                        this.$store.commit('setLoading', false)

                        //     this.$store.commit('setUaePassObject',{})
                        // this.$analytics.fbq.event('loginClick')
                    }
                } catch (error) {
                    this.$store.commit(
                        'setError',
                        'Server error, please try again later'
                    )
                    this.$store.commit('setLoading', false)
                }
            } else {
                this.$store.commit('setError', this.errors.all()[0])
                this.$store.commit('setLoading', false)
            }
        }, // End of onSubmit() method
        async getBrandingData() {
            let { data } = await viewBrandingApi.list()
            this.$store.commit('setDisplaySetting', data.data)
        }, // End of getBrandingData() method
        async login(payLoad) {
            this.$store.commit('setLoading', true)
            try {
                httpRequest.$auth
                    .login(payLoad)
                    .then((response) => {
                        let res = this.CryptoJS.AES.decrypt(
                            response.data.data,
                            process.env.VUE_APP_CSK
                        ).toString(this.CryptoJS.enc.Utf8)

                        res = JSON.parse(res)
                        console.log('login success', res)
                        this.loginResponse
                        // commit('setLoading', false)
                        this.loginResponse = console.log(
                            'loginResponse',
                            this.loginResponse
                        )
                        if (res && res.error) {
                            this.$store.commit('setLoading', false)
                            this.$store.commit('setError', res.error)
                            return
                        }
                        if (typeof res.data.data == 'string') {
                            this.tempData = res
                        }

                        if (this.tempData) {
                            if (this.tempData.data.data.twoFA) {
                                this.sendOPT(this.tempData.data.data)
                            } else {
                                this.loginUser(this.tempData.data.data)
                            }
                        } else {
                            this.$store.commit(
                                'setError',
                                'Could not load data'
                            )
                            this.$store.commit('setLoading', false)

                            //     this.$store.commit('setUaePassObject',{})
                            // this.$analytics.fbq.event('loginClick')
                        }
                    })
                    .catch((error) => {
                        this.$store.commit('setLoading', false)
                        this.$store.commit(
                            'setError',
                            error.response.data.message
                        )
                    })
            } catch (errors) {
                this.$store.commit('setLoading', false)
                this.$store.commit('setError', errors.response.data.message)
            }
        },
        async sendOPT(value) {
            try {
                console.log(value.accessToken)
                this.is_data_fetched = true
                this.otpData = this.formData
                this.otpData.token = value.token
                this.otpData.url = '/auth/login'
                this.$refs.otpmodal.show()
                this.$store.commit('setLoading', false)
            } catch (error) {
                console.log('OTP error: ' + error)
            }

            this.$store.commit('setLoading', false)
        }, // End of sendOtp() method

        async reSendOTP() {
            //this.$refs.otpmodal.hide()
            await this.onSubmit()
        }, // End of reSendOTP() method
        async otpResponse(data) {
            console.log('otpResponse data:', data)
            if (data && data.data && typeof data.data.data == 'string') {
                console.log('indside otpResponse ')
                this.tempData = data.data
                data = this.$decrypt(data.data.data)
                console.log('decoded data', data)
            }
            if (data.accessToken) {
                this.$refs.otpmodal.hide()
                await this.loginUser(data)
            } else {
                this.$store.commit('setError', data.error)
            }
            this.$store.commit('setLoading', false)
        }, // End of otpResponse() method

        async loginUser(data) {
            this.$store.commit('setSuccess', 'Login Successfully')
            this.$store.commit('setToken', data.accessToken)
            this.$store.commit('setTokenExpiry', data.expiresIn)
            this.$store.commit('setUser', data.profile)
            this.$store.commit('setLoading', false)
        },
    }, // End of Component > mounted
} // End of export default
</script>
